/**
 * Ringtone (incoming) and ringback (outgoing), synthesised with WebAudio — no audio files
 * to load, and nothing to fail to download. Browsers only allow sound after the user has
 * interacted with the page; in the ERP they always have, so this plays.
 */
let ctx = null;

function audioCtx() {
    if (!ctx) {
        const AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return null;
        ctx = new AC();
    }
    if (ctx.state === 'suspended') ctx.resume().catch(() => {});
    return ctx;
}

function beep(ac, freqs, start, dur, gain) {
    const g = ac.createGain();
    g.gain.setValueAtTime(0, start);
    g.gain.linearRampToValueAtTime(gain, start + 0.02);
    g.gain.setValueAtTime(gain, start + dur - 0.05);
    g.gain.linearRampToValueAtTime(0, start + dur);
    g.connect(ac.destination);
    for (const f of freqs) {
        const o = ac.createOscillator();
        o.frequency.value = f;
        o.connect(g);
        o.start(start);
        o.stop(start + dur);
    }
}

/**
 * Start a repeating tone. Returns a stop function.
 * @param {'incoming'|'outgoing'} kind
 */
export function startTone(kind) {
    const ac = audioCtx();
    if (!ac) return () => {};
    const play = () => {
        const t = ac.currentTime + 0.05;
        if (kind === 'incoming') {
            beep(ac, [880, 1320], t, 0.35, 0.12);
            beep(ac, [880, 1320], t + 0.5, 0.35, 0.12);
        } else {
            beep(ac, [440, 480], t, 1.0, 0.06);     // the familiar ringback
        }
    };
    play();
    const id = setInterval(play, kind === 'incoming' ? 2000 : 3000);
    return () => clearInterval(id);
}
